import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { ResizeAdvancedAction } from "./ResizeAdvancedAction.js";
import { createBackgroundModel } from "../../internal/models/createBackgroundModel.js";
import { createBackgroundFromModel } from "../../internal/models/createBackgroundFromModel.js";
/**
 * @description Defines an advanced resize with padding.
 * @extends Actions.Resize.ResizeAdvancedAction
 * @memberOf Actions.Resize
 * @see Visit {@link Actions.Resize| Resize} for examples
 */

var ResizePadAction = /*#__PURE__*/function (_ResizeAdvancedAction) {
  _inherits(ResizePadAction, _ResizeAdvancedAction);

  var _super = _createSuper(ResizePadAction);

  function ResizePadAction() {
    _classCallCheck(this, ResizePadAction);

    return _super.apply(this, arguments);
  }

  _createClass(ResizePadAction, [{
    key: "background",
    value:
    /**
     * @description Sets the background.
     * @param {Qualifiers.Background} backgroundQualifier Defines the background color to use instead of
     * transparent background areas or when resizing with padding.
     */
    function background(backgroundQualifier) {
      this._actionModel.background = createBackgroundModel(backgroundQualifier);
      return this.addQualifier(backgroundQualifier);
    }
    /**
     * @description Horizontal position for custom-coordinates based padding.
     * @param {number} x The x position.
     */

  }, {
    key: "offsetX",
    value: function offsetX(x) {
      this._actionModel.x = x;
      return this.addQualifier(new Qualifier('x', x));
    }
    /**
     * @description Vertical position for custom-coordinates based padding
     * @param {number} y The y position.
     */

  }, {
    key: "offsetY",
    value: function offsetY(y) {
      this._actionModel.y = y;
      return this.addQualifier(new Qualifier('y', y));
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var result = _get(_getPrototypeOf(ResizePadAction), "fromJson", this).apply(this, [actionModel]);

      actionModel.background && result.background(createBackgroundFromModel(actionModel.background));
      actionModel.x && result.offsetX(actionModel.x);
      actionModel.y && result.offsetY(actionModel.y);
      actionModel.zoom && result.zoom(actionModel.zoom);
      return result;
    }
  }]);

  return ResizePadAction;
}(ResizeAdvancedAction);

export { ResizePadAction };